import React from 'react';
import type { Theme } from '@mui/material';
import { Box, Stack, Typography } from '@mui/material';
import { PostingStatus } from './lib';

export const postingStatusColor = (theme: Theme, status: PostingStatus) =>
    status === PostingStatus.Within
        ? theme.palette.success.main
        : status === PostingStatus.Out
        ? theme.palette.error.main
        : theme.palette.grey[500];

/** Status is always a dot plus a label, never colour alone. */
const PostingStatusDot: React.FC<{ status: PostingStatus; label: React.ReactNode }> = ({
    status,
    label,
}) => (
    <Stack direction="row" alignItems="center" gap={0.75} component="span" display="inline-flex">
        <Box
            component="span"
            sx={theme => ({
                width: 8,
                height: 8,
                borderRadius: '50%',
                flexShrink: 0,
                bgcolor: postingStatusColor(theme, status),
            })}
        />
        <Typography component="span" variant="body2" noWrap>
            {label}
        </Typography>
    </Stack>
);

export default PostingStatusDot;
